import axios from "axios";
import {API} from "../constants";

export const getDocumentTypes = async (filters) => {
    let url = `${API.DOCUMENTS_TYPES}`
    if (filters) {
        Object.entries(filters).forEach(([k, v]) => {
            url = url + `?${k}=${v}`
        })
    }
    return axios.get(url)
}

export const getAllDocumentTypes = async () => {
    return axios.get(`${API.DOCUMENTS_TYPES}all/`)
}

export const updateDocumentTypes = async (uuid, body) => {
    return axios.patch(`${API.DOCUMENTS_TYPES}${uuid}/`, body)
}